import { isArray } from 'util';
import { mapCollection, sortByProperty } from '../../utils/collection.utils';
import { SaleOrder } from '../sale-order';
import { SaleOrderLineBuilder } from './sale-order-line-builder';
import { parseNumber } from '../../utils/number.utils';

export class SaleOrderBuilder {

  static fromJson(json): SaleOrder {
    return (json) ? new SaleOrder(
      json.hash,
      parseNumber(json.orderDate),
      json.customerHash,
      json.customerBusinessName,
      json.customerTradeName,
      json.traderHash,
      json.traderFirstName,
      json.traderLastName,
      parseNumber(json.orderNumber),
      json.observations,
      json.additionalData,
      json.internalObservations,
      json.paymentMethodHash,
      json.paymentMethodDescription,
      parseNumber(json.subTotalAmount),
      parseNumber(json.vat),
      parseNumber(json.totalVat),
      parseNumber(json.totalAmount),
      parseNumber(json.status),
      json.isPendingStepFinished,
      json.isInvoiceStepFinished,
      json.isDepartureStepFinished,
      json.isPreparationStepFinished,
      json.isPostageStepFinished,
      json.isControlDocumentStepFinished,
      json.sentByEmailDate,
      json.signedByCustomerDate,
      json.personWhoIsGoingToSign,
      json.saleOrderDepartureHash,
      json.saleOrderPreparationHash,
      json.saleOrderBearingHash,
      json.saleOrderControlDocumentHash,
      (isArray(json.saleOrderLines)) ? SaleOrderLineBuilder.fromJsonList(json.saleOrderLines) : [],
      json.isDeposit,
      json.saleOrderKeyCode,
      json.offer
    ) : null;
  }

  static fromJsonList(list): SaleOrder[] {
    return (isArray(list)) ? sortByProperty('orderNumber', 'number', true, mapCollection(SaleOrderBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-builder.ts